import { render } from "./AddGallery.vue?vue&type=template&id=7830892a&scoped=true"
import script from "./AddGallery.vue?vue&type=script&lang=js"
export * from "./AddGallery.vue?vue&type=script&lang=js"

import "./AddGallery.vue?vue&type=style&index=0&id=7830892a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7830892a"]])

export default __exports__